import { queryOptions } from '@tanstack/react-query'
import { api } from './api'

export const agentsQueryOptions = () =>
  queryOptions({
    queryKey: ['agents'],
    queryFn: () => api.agents.list(),
  })

export const agentQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['agents', id],
    queryFn: () => api.agents.get(id),
    enabled: !!id,
  })

export const providersQueryOptions = () =>
  queryOptions({
    queryKey: ['providers'],
    queryFn: () => api.providers.list(),
  })

export const usageSummaryQueryOptions = (days = 30) =>
  queryOptions({
    queryKey: ['usage', 'summary', days],
    queryFn: () => api.usage.summary(days),
  })

export const orgQueryOptions = () =>
  queryOptions({
    queryKey: ['org'],
    queryFn: () => api.org.get(),
  })

export const workspacesQueryOptions = () =>
  queryOptions({
    queryKey: ['workspaces'],
    queryFn: () => api.workspaces.list(),
  })

export const onboardingContactQueryOptions = () =>
  queryOptions({
    queryKey: ['onboarding', 'contact'],
    queryFn: () => api.onboarding.contact.get(),
  })

export const opsSecretsQueryOptions = () =>
  queryOptions({
    queryKey: ['ops', 'secrets'],
    queryFn: () => api.ops.secrets.list(),
  })

export const hostingConnectionsQueryOptions = () =>
  queryOptions({
    queryKey: ['ops', 'hosting-connections'],
    queryFn: () => api.ops.hostingConnections.list(),
  })

export const channelProfilesQueryOptions = () =>
  queryOptions({
    queryKey: ['ops', 'channel-profiles'],
    queryFn: () => api.ops.channelProfiles.list(),
  })

export const channelEndpointsQueryOptions = () =>
  queryOptions({
    queryKey: ['channels', 'endpoints'],
    queryFn: () => api.channels.endpoints.list(),
  })

export const channelEndpointProfilesQueryOptions = () =>
  queryOptions({
    queryKey: ['channels', 'profiles'],
    queryFn: () => api.channels.profiles.list(),
  })

export const channelBindingsQueryOptions = (agentId?: string) =>
  queryOptions({
    queryKey: ['channels', 'bindings', agentId ?? 'all'],
    queryFn: () => api.channels.bindings.list(agentId),
  })

export const offeringPacksQueryOptions = () =>
  queryOptions({
    queryKey: ['offering-packs'],
    queryFn: () => api.offeringPacks.list(),
  })

export const invoicesQueryOptions = () =>
  queryOptions({
    queryKey: ['billing', 'invoices'],
    queryFn: () => api.billing.invoices.list(),
  })
